import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CourseView, getCourseOptions } from '@/module/Author/Course';

export const Route = createFileRoute('/_auth/author/_author/course/_course/$courseId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { courseId } = Route.useParams();
  const { data: course } = useSuspenseQuery(getCourseOptions(courseId));

  return <CourseView course={course} />;
}
